<template>
  <div id="app">
  
   
    <router-view></router-view>
    
    <!-- <router-link :to="{ name: 'CList', params: { projectKey: 'acadia' } }">Contact List</router-link><br/><br/> -->
    <!-- <router-link :to="{ name: 'HelloWorld' }">Hello World</router-link>  -->

   
    <einvoiceFront/>
    <!-- <apiImage/> -->
    <!-- Debugging info -->
    <!-- <p>URL Param: {{ urlParam }}</p> -->
    
 

    <div v-if="normalizedUrlParam === 'ta'">
      <mainMenu msg="Welcome to Your Vue.js App"/>
    </div>
        
    <div v-else-if="first3Char === 'jsn'">
      <g_json :urlParam="urlParam"/>
    </div>

    <!-- Render HelloWorld2 component if urlParam is 'eum' -->
    <div v-else-if="first3Char === 'gyp' || first3Char === 'prj'">
      <APage :urlParam="urlParam"/> 
    </div>
     
     
    <div v-else-if="first3Char === 'wap'">
      <ContactList :urlParam="urlParam"/> 
    </div>

    <div v-else-if="first3Char === 'mai'">
      <login :urlParam="urlParam"/> 
    </div>

    <div v-else-if="first3Char === 'soc'">
      <SocketComponent :urlParam="urlParam"/> 
    </div>

    <div v-else-if="first3Char === 'lc'">
      <listMyCall/> 
    </div>

    <div v-else-if="first3Char === 'sen'">
      <whatsApp/> 
    </div>

    <!-- Display a message if the urlParam is neither 'tm' nor 'eum' -->
    <div v-else>
      <img src="//tenmilecreeknursery.com/cdn/shop/products/sacred-lotus-216017.jpg?v=1675570506" class="zoomImg" alt="Zoom image" style="position: absolute; top: -461.366px; left: -1647.15px; opacity: 0; width: 3023px; height: 3023px; border: none; max-width: none; max-height: none;">
    </div>
   
  </div>

</template>

<script>
import mainMenu from './components/TmNet.vue';
// import WhatApp from './components/WhatApp.vue';
// import HelloWorld from './components/HelloWorld.vue';
import APage from './components/APage.vue';
import g_json from './components/g_json.vue';
 import ContactList from './components/ContactList.vue';
 import listMyCall from './components/listMyCall.vue';
 import SocketComponent from './components/SocketComponent.vue';
 import whatsApp from './components/whatsApp.vue';


// import einvoiceFront from './components/einvoiceFront.vue';
// import apiImage from './components/apiImage.vue';


export default {
  name: 'App',
  components: {
    listMyCall,
    whatsApp,
mainMenu,
    // einvoiceFront,
    // apiImage,
     ContactList,
     SocketComponent,
    // WhatApp,
    // HelloWorld,
    APage,
    g_json
  },

  data() {
    return {
      urlParam: ''
    }
  },
  computed: {
    normalizedUrlParam() {
      return this.urlParam.toLowerCase();
    },
    first3Char() {
      return this.normalizedUrlParam.slice(0, 3);
    }
  },
  created() {
    // Fetch URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    this.urlParam = urlParams.get('p') || '';
    
    console.log('URL Param:', this.urlParam);  // Debugging log
  }
}

</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
